import dynamic from 'next/dynamic'

export const DynamicOutOfStockModal = dynamic(
  () => import('.').then((mod) => mod.OutOfStockModal),
  { ssr: false },
)
